// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__34YfL"};